import React from "react";

import team from '../../../assets/images/meet-the-team.jpg';
import discord from '../../../assets/images/aboutpg_discord.svg';
import location from '../../../assets/images/aboutpg_location.svg';
import heart from '../../../assets/images/aboutpg_heart.svg';

const AboutUs = () => {
    return (
        <section className="about-metafans">
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row items-start">
                    <div className="w-full md:w-5/12 mr-3">
                        <h1 className="lt-white font-bold mb-5">Meet the People behind the MetaFans Project</h1>
                        <h2 className="text-grey font-bold mb-4">Learn about our team.</h2>
                    </div>
                    <div className="w-full md:w-7/12">
                        <img className="mx-auto" src={team} alt="meet the metafans team"></img>
                    </div>
                </div>
                <div className="flex flex-col md:flex-row items-center justify-center about-stats font-bold">
                    <div className="flex items-center w-1/3 justify-start items-center stat-item">
                        <div className="mr-4">
                            <img src={discord} alt="discord users"></img>
                        </div>
                        <div>
                            <p className="text-grey">Discord Users</p>
                            <h2 className="lt-white">11.7k</h2>
                        </div>
                    </div>
                    <div className="flex items-center w-1/3 justify-start items-center stat-item">
                        <div className="mr-4">
                            <img src={location} alt="event numbers"></img>
                        </div>
                        <div>
                            <p className="text-grey">Number Of Events</p>
                            <h2 className="lt-white">120+</h2>
                        </div>
                    </div>
                    <div className="flex items-center w-1/3 justify-start items-center stat-item">
                        <div className="mr-4">
                            <img src={heart} alt="giving back"></img>
                        </div>
                        <div>
                            <p className="text-grey">Money Given Back To Holders</p>
                            <h2 className="lt-white">$20K+</h2>
                        </div>
                    </div>
                </div>
                <div className="about-text">
                    <p className="text-grey font-medium">Created with the love of sports at its core, MetaFans is the first NFT project of its kind, connecting sports fans with VIP experiences. With a commitment to bringing people together, our mission is to provide unforgettable IRL experiences and give back to the community through our charity partnerships.</p>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;